import { render, staticRenderFns } from "./thirdPage.vue?vue&type=template&id=4adb6592"
import script from "./thirdPage.vue?vue&type=script&lang=js"
export * from "./thirdPage.vue?vue&type=script&lang=js"
import style0 from "./thirdPage.vue?vue&type=style&index=0&id=4adb6592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports